import { select } from "redux-saga/effects";

import { history } from "state/history";
import { getDinnerBookingByID } from "state/school_money/selectors";

export default function* goToDinnerBookingSaga(action) {
  
  const { dinnerBookingID } = action.payload;
  
  const dinnerBooking = yield select(getDinnerBookingByID, dinnerBookingID);
  const studentID = dinnerBooking.get("studentID");
  
  history.push(`/school_money/dinners/${studentID}/`);
  
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/goToDinnerBookingSaga.js